export default __webpack_public_path__ + "static/100--stacked-column-5a404ccf768ef373573aab0a43749f8b.png";